import { memo, ReactNode } from 'react';

import { Flex, ProgressBar, Text } from '@/components/core';

import { SectionCard, SectionCardProps } from './Section';

type UsageCardProps = {
  resource: string;
  used?: number;
  available?: number;
  icon: ReactNode;
} & SectionCardProps;

const IUsageCard = ({ resource, used, available, icon, ...rest }: UsageCardProps) => {
  return (
    <SectionCard {...rest}>
      <Flex col className="gap-xs w-full">
        <Flex className="gap-sm items-center">
          {icon}
          <Text className="font-semibold">{resource}</Text>
        </Flex>

        <Flex col className="gap-xs w-full items-stretch">
          <Text size="xs">
            {used} / {available}
          </Text>
          <ProgressBar maxValue={available} value={used} variant="primary" />
        </Flex>
      </Flex>
    </SectionCard>
  );
};

export const UsageCard = memo(IUsageCard) as typeof IUsageCard;
